<template>
<div>
    <!-- Loading skeleton -->
    <b-card v-if="getLoding">
        <b-skeleton animation="wave" width="100%"></b-skeleton>
        <b-skeleton animation="wave" width="100%"></b-skeleton>
    </b-card>

    <!-- Navbar -->
    <b-navbar toggleable="lg" v-else class="custom-navbar">
        <b-navbar-brand to="/home">
            <img src="../../../assets/images/login2.png" class="colored-image" alt="Logo" />
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav class="ml-auto navbar-items">

                <!-- Home -->
                <b-nav-item @click="$route.name != 'institute' ? $router.push({ name: 'institute' }) : ''">
                   <br>
                    <span><i class="fas fa-home"></i></span>
                    <br />
                    <em>Home</em>
                    <br>
                </b-nav-item>
                <br>

                <!-- Institute Dropdown -->
                <b-nav-item-dropdown>
                    <template #button-content>
                        <div class="dropdown-btn-block">
                            <span><i class="fas fa-university"></i></span>
                            <em>
                                {{ institute.id && institute.name ? institute.code : "Institute" }}
                                <i class="fas fa-caret-down caret-icon" style="font-size: 15px!important;"></i>
                            </em>
                        </div>
                    </template>

                    <b-dropdown-group>
                        <InstituteListDropdown />
                    </b-dropdown-group>
                </b-nav-item-dropdown>

                <br>

                <!-- Notifications -->
                <b-nav-item-dropdown>
                    <template #button-content>
                        <div class="dropdown-btn-block">
                            <span><i class="fas fa-bell"></i></span>
                            <em>
                                Notifications
                                <i class="fas fa-caret-down caret-icon" style="font-size: 15px!important;"></i>
                            </em>
                        </div>
                    </template>

                    <b-dropdown-item>
                        <Notifications />
                    </b-dropdown-item>
                </b-nav-item-dropdown>
                <br>

                <!-- Profile -->
                <b-nav-item-dropdown class="profile-dropdown">
                    <template #button-content>
                        <div class="dropdown-btn-block">
                            <span>
                                <i class="fas fa-user-circle" v-if="!profile.profile_image"></i>
                                <img v-else :src="cloudStorageRoot + profile.profile_image.file_path + profile.profile_image.file_name"
                                     alt="profile" class="rounded-circle profile-image" />
                            </span>
                            <em>
                                {{ profile.id ? profile.first_name : "Name" }}
                                <i class="fas fa-caret-down caret-icon" style="font-size: 15px!important;"></i>
                            </em>
                        </div>
                    </template>

                    <b-dropdown-item @click="$route.name != 'MyProfile' ? $router.push({ name: 'MyProfile' }) : ''">My profile</b-dropdown-item>
                    <b-dropdown-item @click="logoutUser">Logout</b-dropdown-item>
                </b-nav-item-dropdown>
                <br>

                <!-- Help -->
                <b-nav-item v-if="$store.state.userRole != 'Student'" @click="openHelpInNewTab">
                    <br>
                    <span><i class="fas fa-question-circle"></i></span>
                    <br />
                    <em>Help</em>
                    <br>
                </b-nav-item>

            </b-navbar-nav>
            <br>
        </b-collapse>
    </b-navbar>
</div>
</template>

<script>
import acl from "../../../authorization/acl";
import InstituteListDropdown from "../Dashboard/Institute/InstituteListDropdown.vue";
import Notifications from "../Dashboard/Notifications.vue";

export default {
    async created() {
        this.fetchData = true;
        this.cloudStorageRoot = this.$store.getters.getAPIKey.userAttachments;
        await this.$store.dispatch("getMyProfile");
        await this.$store.dispatch("getUser");
        try {
            const studentRole = await acl.isUserGranted("viewStudentTab");
            this.enableHelp = !studentRole && this.$store.state.userRole != 'Student';
        } catch (error) {
            console.error(error);
        }
        this.fetchData = false;
    },
    components: {
        InstituteListDropdown,
        Notifications,
    },
    data() {
        return {
            enableHelp: true,
            cloudStorageRoot: null,
            username: "",
            fetchData: false,
        };
    },
    computed: {
        profile() {
            return this.$store.getters.getMyProfile;
        },
        getLoding() {
            return this.$store.getters.getInstituteStatus;
        },
        institute() {
            return this.$store.getters.getCurrentInstitution;
        },
    },
    methods: {
        openHelpInNewTab() {
            const route = this.$router.resolve({ name: 'helpAndQuestions', params: { tab: 'questions' } });
            window.open(route.href, '_blank');
        },
        async logoutUser() {
            await this.$store.dispatch("logoutUser");
        },
    },
};
</script>

<style>
/* =======================
   Navbar Height
   ======================= */
.custom-navbar {
    background-color: #ffffff;
    padding-top: 20px !important;
    padding-bottom: 15px !important;
    height: 57px !important;
}

/* Logo */
.custom-navbar .colored-image {
    width: 40px;
    height: 40px;
    fill: #1ea2ed; /* SVG color */
}

/* Equal spacing */
.navbar-items {
    display: flex !important;
    justify-content: flex-end !important;
    align-items: center;
    gap: 35px !important;
    width: 100%;
    padding-right: 10px;
}

/* Nav items */
.navbar-items .nav-item,
.navbar-items .dropdown {
    display: flex !important;
    flex-direction: column;
    align-items: center !important;
    justify-content: center;
    text-align: center !important;
    width: 70px;
    padding: 0 !important;
    margin: 0 !important;
}

/* Icons */
.navbar-items .nav-item span i,
.navbar-items .dropdown span i {
    font-size: 18px !important;
    color: #7a7a7a !important;
}
.navbar-items em,
.dropdown-btn-block em {
    font-style: normal !important;
}

/* Text under icon */
.navbar-items .nav-item em,
.navbar-items .dropdown em {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 3px !important;
    font-size: 11px !important;
    color: #7a7a7a !important;
    gap: 3px;
}

/* Hide default bootstrap caret */
.dropdown-toggle::after {
    display: none !important;
}

/* New caret */
.caret-icon {
    font-size: 10px;
    color: #7a7a7a;
}

/* Dropdown button block (icon top, text center) */
.dropdown-btn-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

/* Profile dropdown */
.navbar .profile-dropdown .dropdown-menu {
    width: 250px;
}

.navbar .profile-dropdown .dropdown-item {
    border-bottom: 2px solid #d2d2d2;
}

.navbar .profile-dropdown .dropdown-item:hover {
    background-color: #1ea2ed;
    color: #ffffff !important;
}

/* Profile image */
.profile-image {
    width: 28px;
    height: 28px;
    display: block;
    margin: 0 auto;
}

/* Mobile */
@media only screen and (max-width: 600px) {
    .navbar-items {
        justify-content: center !important;
        gap: 20px !important;
        padding-right: 0 !important;
    }

    .navbar-items .nav-item,
    .navbar-items .dropdown {
        width: 60px !important;
    }
}
</style>
